var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spwwHeaderPage disFlex" }, [
    _c("div", { staticClass: "mainCont" }, [
      _c("div", { staticClass: "leftCont" }, [
        _c("img", { attrs: { src: _vm.logoSrc, width: "115" } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rightCont" }, [
        _c(
          "ul",
          { staticClass: "nav navbar-nav disFlex" },
          [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _vm._v(_vm._s(_vm.$t("spww.home"))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("lang-select", { staticClass: "right-menu-item hover-effect" }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }